import { useFetchCorporateSingleMatrix } from '../../../utils/queries/corporate';
import SingleMatrixCard from '../../Common/SingleMatrixCard';
import { useHistory } from 'react-router-dom';
import { round } from 'lodash';

const CorporateMatrixTiles = ({ corporateId }) => {
  const { data, isLoading, error } = useFetchCorporateSingleMatrix(corporateId);
  const history = useHistory();
  const cardClickHandler = (tileIndex) => {
    if (tileIndex === 0) {
      history.push(`/corporates/chargers/${corporateId}`);
    }
  };

  return (
    <>
      <div
        className="header-body"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
        }}
      >
        {/* Available Chargers */}
        <SingleMatrixCard
          cardTitle="Available"
          data={data?.ONLINE_CHARGERS}
          isLoading={isLoading}
          error={error}
          color="#28a745"
          isClickable
          clickHandler={() => cardClickHandler('1', '2', 'Online')}
          isActive={false}
        />

        {/* CHARGERS OFFLINE */}
        <SingleMatrixCard
          cardTitle="Offline"
          data={data?.TOTAL_CHARGERS - data?.ONLINE_CHARGERS}
          isLoading={isLoading}
          error={error}
          color="#e61b1b"
          isClickable
          clickHandler={() => cardClickHandler('1', '3', 'Offline')}
          isActive={false}
        />
        {/* Chargers In use */}

        <SingleMatrixCard
          cardTitle="In Use"
          data={data?.IN_USE}
          isLoading={isLoading}
          error={error}
          isClickable
          clickHandler={() => cardClickHandler(0)}
          isActive={false}
        />

        {/* Enable Chargers */}

        <SingleMatrixCard
          cardTitle="Enabled"
          data={data?.ENABLED_CHARGERS}
          isLoading={isLoading}
          error={error}
          color="#5e72e4"
          isClickable
          clickHandler={() => cardClickHandler('1', '4', 'Enabled')}
          isActive={false}
        />

        {/* ENERGY SOLD */}

        <SingleMatrixCard
          cardTitle="Energy"
          data={round(data?.ENERGY_CONSUMED, 2)}
          isLoading={isLoading}
          error={error}
          suffix={<span style={{ fontSize: '12px' }}>kWh</span>}
          isClickable
          clickHandler={() => cardClickHandler('3', '6')}
          isActive={false}
        />

        {/* NET REVENUE (with GST) */}

        {/* <SingleMatrixCard
        cardTitle="Net Revenue"
        subTitle="(with GST)"
        data={data?.AMOUNT_CONSUMED}
        isLoading={isLoading}
        error={error}
        prefix={<span style={{ fontSize: '18px' }}>₹</span>}
        isClickable
        clickHandler={() => cardClickHandler('3', '7')}
        isActive={false}
      /> */}
      </div>
      <div
        className="header-body"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          paddingRight: 0,
        }}
      >
        {/* NET REVENUE (without GST) */}

        <SingleMatrixCard
          cardTitle="Net Revenue"
          subTitle="(without GST)"
          data={round(data?.AMOUNT_CONSUMED / 100, 2)}
          isLoading={isLoading}
          error={error}
          prefix={<span style={{ fontSize: '18px' }}>₹</span>}
          isClickable
          clickHandler={() => cardClickHandler('3', '7')}
          isActive={false}
        />

        {/* CO2 Emission Saved */}

        <SingleMatrixCard
          cardTitle="CO2 Emission Saved"
          subTitle=""
          data={round(data?.CO2_EMISSION_SAVED / 100, 2)}
          isLoading={isLoading}
          error={error}
          suffix={<span style={{ fontSize: '18px' }}>Kg</span>}
          isClickable={false}
          //clickHandler={() => cardClickHandler('3', '7')}
          isActive={false}
        />

        {/* Trees Saved */}

        <SingleMatrixCard
          cardTitle="Trees Saved"
          subTitle=""
          data={round(data?.TREES_SAVED)}
          isLoading={isLoading}
          error={error}
          //prefix={<span style={{ fontSize: '18px' }}>₹</span>}
          isClickable={false}
          //clickHandler={() => cardClickHandler('3', '7')}
          isActive={false}
        />
      </div>
    </>
  );
};

export default CorporateMatrixTiles;
